import { render, staticRenderFns } from "./PromotionInfoTable.vue?vue&type=template&id=e519912e&scoped=true"
import script from "./PromotionInfoTable.vue?vue&type=script&lang=js"
export * from "./PromotionInfoTable.vue?vue&type=script&lang=js"
import style0 from "./PromotionInfoTable.vue?vue&type=style&index=0&id=e519912e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e519912e",
  null
  
)

export default component.exports